export default "__VITE_ASSET__DCg6uPT9__"